import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const reportSynthetic = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/reports/synthetic?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar relatório')
        })
}

const reportDetailSend = (objectQueryString) => {
    let querySend = querystring.stringify(objectQueryString)
    return api.get(`/reports/send-by-month?${querySend}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar relatório')
        })
}

const reportDetailReceived = (objectQueryString) => {
    let queryReceived = querystring.stringify(objectQueryString)
    return api.get(`/reports/received-by-month?${queryReceived}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar relatório')
        })
}

const store = (data) => {
    return api.post('/reports/analytical', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar relatório')
        })
}

const all = (objectQueryString) => {
    let queryReceived = querystring.stringify(objectQueryString)
    return api.get(`/reports/analytical?${queryReceived}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a lista de relatórios')
        })
}

const log = (objectQueryString) => {
    let queryReceived = querystring.stringify(objectQueryString)
    return api.get(`/reports/analytical/log?${queryReceived}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível enviar o log.')
        })
}

export default {
    reportSynthetic,
    reportDetailSend,
    reportDetailReceived,
    store,
    log,
    all
}
